module.exports = __webpack_public_path__ + "static/media/flatbread-product-2.d1cee87f.svg";